import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { OfferStreamRecord, StreamHistory } from '../../../_models';
import { AuthenticationService, NotificationService, EnvService, StreamHistoryService, StreamKeywordService, AdvertiserService, AdvertiserAffiliateService, OfferStreamHistoryService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-offer-stream-history',
  templateUrl: './stream-history.component.html'
})
export class OfferStreamHistoryComponent implements OnInit {
  streamList: Array<OfferStreamRecord> = [];
  loading = false;
  processing = false;
  //pagination
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = true;
  maxPageSize: number;

  filterable = {
    fromDate: '',
    toDate: new Date().toISOString().substring(0, 10),
    panOutState: '',
    advertiser: null,
    affiliate: null,
    queryString: null,
  };

  advertiserList: any = [];
  affiliateList: any = [];
  panOutStateList = {};

  constructor(private authSvc: AuthenticationService,
    private envSvc: EnvService,
    private advertiserSvc: AdvertiserService,
    private affiliateSvc: AdvertiserAffiliateService,
    private historySvc: OfferStreamHistoryService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable.fromDate = dte.toISOString().substring(0, 10);
    this.loadPanOutStates();
    this.loadAdvertiserList();
  }

  search() {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable = {
      fromDate: dte.toISOString().substring(0, 10),
      toDate: new Date().toISOString().substring(0, 10),
      panOutState: '',
      advertiser: null,
      affiliate: null,
      queryString: null,
    };
    this.affiliateList = [];
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onClear() {
    this.filterable.advertiser = this.advertiserList[0];
    this.filterable.affiliate = null;
    this.filterable.queryString = null;
    this.filterable.panOutState = null;
    this.changeAdvertiser(this.filterable.advertiser);
  }

  changeAdvertiser(advertiser) {
    this.filterable.advertiser = advertiser;
    this.affiliateList = [];
    this.filterable.affiliate = null;
    if (advertiser) {
      this.affiliateSvc.getAllForSelection(advertiser.id).pipe(first()).subscribe(data => {
        this.affiliateList = data.data;
        if(this.affiliateList == null){
          this.affiliateList = [];
        }
      });
    }
  }

  private loadPanOutStates() {
    this.envSvc.getPanOutStates().pipe(first()).subscribe(data => {
      this.panOutStateList = data.data;
    });
  }

  private loadAdvertiserList() {
    this.advertiserSvc.getAllAdvertiserForSelection().pipe(first()).subscribe(data => {
      this.advertiserList = data.data;
      this.filterable.advertiser = this.advertiserList[0];
      this.changeAdvertiser(this.filterable.advertiser);
    });
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.streamList = [];
    let params = this.formParam(page);
    // get page of items from api
    this.historySvc.getAll(params).pipe(first()).subscribe(data => {
      if (data && data.data) {
        this.loading = false;
        this.streamList = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      from: formatDate(this.filterable.fromDate, 'yyyyMMdd', 'en'),
      to: formatDate(this.filterable.toDate, 'yyyyMMdd', 'en'),
      state: this.filterable.panOutState,
      advertiserId: this.filterable.advertiser.id,
      affiliate: this.filterable.affiliate == null ? "" : this.filterable.affiliate.affiliate,
      queryStr: this.filterable.queryString,
    }
    return params;
  }

}
